
export type MainMenuItem = {
  title: string,
  key: string,
  url: string,
  blank: boolean,
  outlined: boolean,
  border?: string
}

export type Response = {
  left: MainMenuItem[],
  right: MainMenuItem[]
}

const useMainMenu = (): Response => {
  return {
    left: [
      { title: 'Start', key: 'start', url: '/', blank: false, outlined: false, border: '#ffffff' },
      { title: 'Dlaczego my?', key: 'dlaczego-my', url: '/dlaczego-my', blank: false, outlined: false, border: '#ffffff' },
      { title: 'Proces rekrutacji', key: 'proces-rekrutacji', url: '/#proces-rekrutacji', blank: false, outlined: false, border: '#ffffff' },
      { title: 'Praktyki i staże', key: 'praktyki-i-staze', url: '/praktyki-i-staze', blank: false, outlined: false, border: '#ffffff' },
    ],
    right: [
      { title: 'Aktualne oferty pracy', key: 'aktualne-oferty-pracy', url: '/aktualne-oferty-pracy', blank: false, outlined: true }
    ]
  }
}

export default useMainMenu